import { InjectionToken } from '@angular/core';

export enum FinnairTheme {
  LEGACY = 'legacy', // @deprecated, use LIGHT_THEME or DARK_THEME instead - to be removed
  LIGHT_THEME = 'light-theme',
  DARK_THEME = 'dark-theme',
}

export const FINNAIR_THEME_COOKIE_NAME = 'finnair-theme';

export const FINNAIR_THEME: InjectionToken<FinnairTheme> = new InjectionToken<FinnairTheme>('FinnairTheme');
